import { useQuery, UseQueryResult } from "react-query"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import ResponseError from "utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { MemberJourneyData } from "../../../types/MemberJourney"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENTITY = "MemberJourney"

export default function useGetMemberJourney(employeeId: number): UseQueryResult<MemberJourneyData, ResponseError> {
  const useGetMemberJourneyQuery = useQuery<MemberJourneyData, ResponseError>(
    [ENTITY, employeeId],
    () => client.getMemberJourney(employeeId),
    {
      ...RetryConfig
    }
  )

  return useGetMemberJourneyQuery
}
